import SectionBasePage from 'components/SectionBasePage';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  productionItemsIdsSelector,
  getProductionItemAction,
  productionItemDetailEntitiesSelector,
  isLoadingProductionItemDetailSelector,
} from 'state/slices/productionItem';
import { Skeleton } from 'UI';

import {
  Summary,
  Progress,
} from './components';

import {
  LoadingContainer,
  MainContainer,
} from './style';

interface ProductionItemRouteParams {
  prodItemId: string
}

const ProductionItemPage = (): JSX.Element => {
  const dispatch = useDispatch();
  const { prodItemId: itemUrlId } = useParams<ProductionItemRouteParams>();

  const productionItemId = useSelector(productionItemsIdsSelector)
    .find((curProdItemId) => `${curProdItemId}` === itemUrlId) || '';
  const productionItemsEntities = useSelector(productionItemDetailEntitiesSelector);
  const productionItem = productionItemsEntities[productionItemId];
  const isItemLoading = useSelector(isLoadingProductionItemDetailSelector);

  useEffect(() => {
    if (itemUrlId) {
      dispatch(getProductionItemAction({
        productionItemId: itemUrlId,
      }));
    }
  }, [itemUrlId]);

  return (
    <>
      {
        isItemLoading || !productionItem ? (
          <SectionBasePage>
            <LoadingContainer>
              <Skeleton />
            </LoadingContainer>
          </SectionBasePage>
        ) : (
          <SectionBasePage>
            <MainContainer>
              {/* Summary */}
              <Summary
                item={productionItem}
              />

              {/* Progress */}
              <Progress
                item={productionItem}
              />
            </MainContainer>
          </SectionBasePage>
        )
      }
    </>
  );
};

export default ProductionItemPage;
